export default [
    {
        "id": "1",
        "img": require("@/assets/tic/qq/1.gif")
    },
    {
        "id": "2",
        "img": require("@/assets/tic/qq/2.gif")
    },
    {
        "id": "3",
        "img": require("@/assets/tic/qq/3.gif")
    },
    {
        "id": "4",
        "img": require("@/assets/tic/qq/4.gif")
    },
    {
        "id": "5",
        "img": require("@/assets/tic/qq/5.gif")
    },
    {
        "id": "6",
        "img": require("@/assets/tic/qq/6.gif")
    },
    {
        "id": "7",
        "img": require("@/assets/tic/qq/7.gif")
    },
    {
        "id": "8",
        "img": require("@/assets/tic/qq/8.gif")
    },
    {
        "id": "9",
        "img": require("@/assets/tic/qq/9.gif")
    },
    {
        "id": "10",
        "img": require("@/assets/tic/qq/10.gif")
    },
    {
        "id": "11",
        "img": require("@/assets/tic/qq/11.gif")
    },
    {
        "id": "12",
        "img": require("@/assets/tic/qq/12.gif")
    },
    {
        "id": "13",
        "img": require("@/assets/tic/qq/13.gif")
    },
    {
        "id": "14",
        "img": require("@/assets/tic/qq/14.gif")
    },
    {
        "id": "15",
        "img": require("@/assets/tic/qq/15.gif")
    },
    {
        "id": "16",
        "img": require("@/assets/tic/qq/16.gif")
    },
    {
        "id": "17",
        "img": require("@/assets/tic/qq/17.gif")
    },
    {
        "id": "18",
        "img": require("@/assets/tic/qq/18.gif")
    },
    {
        "id": "19",
        "img": require("@/assets/tic/qq/19.gif")
    },
    {
        "id": "20",
        "img": require("@/assets/tic/qq/20.gif")
    },
    {
        "id": "21",
        "img": require("@/assets/tic/qq/21.gif")
    },
    {
        "id": "22",
        "img": require("@/assets/tic/qq/22.gif")
    },{
        "id": "23",
        "img": require("@/assets/tic/qq/23.gif")
    },
    {
        "id": "24",
        "img": require("@/assets/tic/qq/24.gif")
    },
    {
        "id": "25",
        "img": require("@/assets/tic/qq/25.gif")
    },
    {
        "id": "26",
        "img": require("@/assets/tic/qq/26.gif")
    },
    {
        "id": "27",
        "img": require("@/assets/tic/qq/27.gif")
    },
    {
        "id": "28",
        "img": require("@/assets/tic/qq/28.gif")
    },
    {
        "id": "29",
        "img": require("@/assets/tic/qq/29.gif")
    },
    {
        "id": "30",
        "img": require("@/assets/tic/qq/30.gif")
    },
    {
        "id": "31",
        "img": require("@/assets/tic/qq/31.gif")
    },
    {
        "id": "32",
        "img": require("@/assets/tic/qq/32.gif")
    },
    {
        "id": "33",
        "img": require("@/assets/tic/qq/33.gif")
    },
    {
        "id": "34",
        "img": require("@/assets/tic/qq/34.gif")
    },
    {
        "id": "35",
        "img": require("@/assets/tic/qq/35.gif")
    },
    {
        "id": "36",
        "img": require("@/assets/tic/qq/36.gif")
    },
    {
        "id": "37",
        "img": require("@/assets/tic/qq/37.gif")
    },
    {
        "id": "38",
        "img": require("@/assets/tic/qq/38.gif")
    },
    {
        "id": "39",
        "img": require("@/assets/tic/qq/39.gif")
    },
    {
        "id": "40",
        "img": require("@/assets/tic/qq/40.gif")
    },
    {
        "id": "41",
        "img": require("@/assets/tic/qq/41.gif")
    },
    {
        "id": "42",
        "img": require("@/assets/tic/qq/42.gif")
    },
    {
        "id": "43",
        "img": require("@/assets/tic/qq/43.gif")
    },
    {
        "id": "44",
        "img": require("@/assets/tic/qq/44.gif")
    },
    {
        "id": "45",
        "img": require("@/assets/tic/qq/45.gif")
    },
    {
        "id": "46",
        "img": require("@/assets/tic/qq/46.gif")
    },
    {
        "id": "47",
        "img": require("@/assets/tic/qq/47.gif")
    },{
        "id": "48",
        "img": require("@/assets/tic/qq/48.gif")
    },
    {
        "id": "49",
        "img": require("@/assets/tic/qq/49.gif")
    },
    {
        "id": "50",
        "img": require("@/assets/tic/qq/50.gif")
    },
    {
        "id": "51",
        "img": require("@/assets/tic/qq/51.gif")
    },
    {
        "id": "52",
        "img": require("@/assets/tic/qq/52.gif")
    },
    {
        "id": "53",
        "img": require("@/assets/tic/qq/53.gif")
    },
    {
        "id": "54",
        "img": require("@/assets/tic/qq/54.gif")
    },
    {
        "id": "55",
        "img": require("@/assets/tic/qq/55.gif")
    },
    {
        "id": "56",
        "img": require("@/assets/tic/qq/56.gif")
    },
    {
        "id": "57",
        "img": require("@/assets/tic/qq/57.gif")
    },
    {
        "id": "58",
        "img": require("@/assets/tic/qq/58.gif")
    },
    {
        "id": "59",
        "img": require("@/assets/tic/qq/59.gif")
    },
    {
        "id": "60",
        "img": require("@/assets/tic/qq/60.gif")
    },
    {
        "id": "61",
        "img": require("@/assets/tic/qq/61.gif")
    },
    {
        "id": "62",
        "img": require("@/assets/tic/qq/62.gif")
    },
    {
        "id": "63",
        "img": require("@/assets/tic/qq/63.gif")
    },
    {
        "id": "64",
        "img": require("@/assets/tic/qq/64.gif")
    },
    {
        "id": "65",
        "img": require("@/assets/tic/qq/65.gif")
    },
    {
        "id": "66",
        "img": require("@/assets/tic/qq/66.gif")
    },
    {
        "id": "67",
        "img": require("@/assets/tic/qq/67.gif")
    },
    {
        "id": "68",
        "img": require("@/assets/tic/qq/68.gif")
    },
    {
        "id": "69",
        "img": require("@/assets/tic/qq/69.gif")
    },
    {
        "id": "70",
        "img": require("@/assets/tic/qq/70.gif")
    },
    {
        "id": "71",
        "img": require("@/assets/tic/qq/71.gif")
    },
    {
        "id": "72",
        "img": require("@/assets/tic/qq/72.gif")
    },{
        "id": "73",
        "img": require("@/assets/tic/qq/73.gif")
    },
    {
        "id": "74",
        "img": require("@/assets/tic/qq/74.gif")
    },
    {
        "id": "75",
        "img": require("@/assets/tic/qq/75.gif")
    },
    {
        "id": "76",
        "img": require("@/assets/tic/qq/76.gif")
    }
]


// WEBPACK FOOTER //
// ./src/views/classroom1/components/emoji.js